export default __webpack_public_path__ + "static/about-us-7bd5cd4785d2b3917c797e12c892a670.jpg";